import { IndicatorSettingsDefaults } from "../components/settingsHelper/GeneralSettingsDefaults";

export const combineObject = (val) => {
    if (!val) return val;
    const singleDefaults = IndicatorSettingsDefaults.indicatorSettings?.single || {};
    const allKeys = Array.from(new Set([...Object.keys(singleDefaults), ...Object.keys(val)]));
    for (let i = 0; i < allKeys.length; i++) {
        const key = allKeys[i];
        try {
            const fetchObj = val[key] || {};
            const defaultObj = singleDefaults[key] || {};
            val[key] = { ...defaultObj, ...fetchObj };
        } catch (error) {
            val[key] = val[key];
        }
    }
    return val;
};

export const combineAdditionalObject = (val) => {
    if (!val) return val;
    const additionalDefaults = IndicatorSettingsDefaults.indicatorSettings?.additional || {};
    const allKeys = Array.from(new Set([...Object.keys(additionalDefaults), ...Object.keys(val)]));
    for (let i = 0; i < allKeys.length; i++) {
        const key = allKeys[i];
        try {
            const fetchObj = val[key] || {};
            const defaultObj = additionalDefaults[key] || {};
            val[key] = { ...defaultObj, ...fetchObj };
        } catch (error) {
            val[key] = val[key];
        }
    }
    return val;
};
